export default __webpack_public_path__ + "static/media/editlg-orange.90bccc62.svg";